/**
 * Miscelleanous  Function
 */

// 1. Function for adding icon and removing text from resource search bar
const resourceSearchButton = document.querySelector(".ocfp-resources-filters-row  .frm_button_submit ");
//
if (resourceSearchButton) {
	resourceSearchButton.innerHTML = "<i class='fa-solid fa-magnifying-glass'></i>";
	resourceSearchButton.style.display = "flex";
	// resourceSearchBarInput.setAttribute("placeholder", "Search all resources");
}

// 2. Function to scroll down to search results on resources page
const resourceCurrentURL = window.location.search;
if (resourceCurrentURL.includes("search")) {
	const ocfpResourcesSection = document.getElementById("ocfpResources");
	ocfpResourcesSection.scrollIntoView();
}

// Header menu active state
const currentURL = window.location;
// console.log(currentURL);
const currentURLSlugPaths = window.location.pathname.split("/");
const currentURLSlugFirstPath = currentURLSlugPaths.slice(1)[0];
const headerNav = document.querySelector("#ocfp-main-header");
if (headerNav) {
	// For portal pages
	if (currentURLSlugFirstPath == "portal") {
		const navItemsHref = Array.from(document.querySelectorAll("#menu-main-menu > li > a"))
			.map((a) => {
				const url = new URL(a).pathname;
				return {
					el: a,
					path: url,
				};
			})
			.filter((a) => ["/", "/portal", "/portal/"].includes(a.path));

		// Add active-link style to first instance
		navItemsHref[0].el.parentElement.classList.add("active-link");
	}

	if (currentURLSlugFirstPath == "resource-category") {
		const navItemsHref = Array.from(document.querySelectorAll("#menu-main-menu > li > a"))
			.map((a) => {
				const url = new URL(a).pathname;
				return {
					el: a,
					path: url,
				};
			})
			.filter((a) => ["/resources", "/resources/"].includes(a.path));

		// Add active-link style to first instance
		navItemsHref[0].el.parentElement.classList.add("active-link");
	}
}
